import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Paginator } from "primereact/paginator";
import { ProgressSpinner } from "primereact/progressspinner";

const HistoryLogsDatatableComponent = ({
  data,
  filters,
  setFilters,
  header,
  loading,
  first,
  rows,
  totalRecords,
  onPageChange,
  onSort,
  sortField,
  sortOrder,
}) => {
  const formatDate = (value) => {
    if (!value) return "";
    const date = new Date(value);
    return new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    }).format(date);
  };

  const formatAction = (action) => {
    return action
      .replace(/_/g, " ")
      .toLowerCase()
      .replace(/\b\w/g, (l) => l.toUpperCase());
  };

  return (
    <div className="table-container">
      {loading ? (
        <div className="loader-container">
          <ProgressSpinner />
        </div>
      ) : (
        <>
          <DataTable
            style={{ fontFamily: "poppins" }}
            value={data}
            paginator={false}
            responsiveLayout="scroll"
            filters={filters}
            globalFilterFields={[
              "action",
              "userId",
              "username",
              "formId",
              "formSchemaId",
              "ipAddress",
              "timestamp",
            ]}
            header={header}
            emptyMessage="No logs found."
            onFilter={(e) => setFilters(e.filters)}
            sortField={sortField}
            sortOrder={sortOrder}
            onSort={onSort}
          >
            <Column
              field="action"
              header="Action"
              body={(rowData) => formatAction(rowData.action)}
              style={{ width: "15%" }}
              sortable
            ></Column>
            <Column
              field="username"
              header="User Name"
              style={{ width: "10%" }}
              sortable
            ></Column>

            <Column
              field="formSchemaId"
              header="Form ID"
              body={(rowData) => rowData.formSchemaId || "N/A"}
              style={{ width: "20%" }}
              sortable
            ></Column>
            <Column
              field="filledFormId"
              header="Filled Form ID"
              body={(rowData) => rowData.filledFormId || "N/A"}
              style={{ width: "20%" }}
              sortable
            ></Column>
            <Column
              field="ipAddress"
              header="IP Address"
              style={{ width: "15%" }}
              sortable
            ></Column>
            <Column
              field="timestamp"
              header="Timestamp"
              body={(rowData) => formatDate(rowData.timestamp)}
              style={{ width: "25%" }}
              sortable
            ></Column>
          </DataTable>
          <Paginator
            first={first}
            rows={rows}
            totalRecords={totalRecords}
            onPageChange={onPageChange}
          ></Paginator>
        </>
      )}
    </div>
  );
};

export default HistoryLogsDatatableComponent;
